import React from 'react'

const StepSelector = ({ steps, currentStep, onStepChange, completedSteps, errorSteps = [] }) => {
    return (
        <div className="space-y-2">
            {steps.map((step, index) => {
                const isError = errorSteps.includes(index);
                const isCompleted = completedSteps.includes(index);
                const isCurrent = currentStep === index;

                return (
                    <button
                        key={index}
                        onClick={() => onStepChange(index)}
                        className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg transition text-left ${
                            isCurrent ? 'bg-blue-100 dark:bg-blue-900/30 border-l-4 border-blue-500' :
                            isError ? 'bg-red-50 dark:bg-red-900/20 hover:bg-red-100 dark:hover:bg-red-900/30' :
                            isCompleted ? 'bg-emerald-50 dark:bg-emerald-900/20 hover:bg-emerald-100 dark:hover:bg-emerald-900/30' :
                            'bg-gray-50 dark:bg-gray-700/20 hover:bg-gray-100 dark:hover:bg-gray-700/40 opacity-50 cursor-not-allowed'
                        }`}
                        disabled={!isCompleted && !isError && !isCurrent}
                    >
                        <div className={`w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold flex-shrink-0 ${
                            isError ? 'bg-red-500 text-white' :
                            isCompleted ? 'bg-emerald-500 text-white' :
                            isCurrent ? 'bg-blue-500 text-white' :
                            'bg-gray-300 dark:bg-gray-600 text-gray-600 dark:text-gray-300'
                        }`}>
                            {isError ? '✕' : isCompleted ? '✓' : index + 1}
                        </div>
                        <div className="flex-1 min-w-0">
                            <p className={`text-sm font-medium ${isCurrent ? 'text-blue-600 dark:text-blue-400' : isError ? 'text-red-600 dark:text-red-400' : ''}`}>{step}</p>
                        </div>
                    </button>
                );
            })}
        </div>
    );
};

export default StepSelector
